import { previewSelectedResourcesSelector } from "./previewSelectedResourcesSelector";
import { ResourceType } from "@/services/cloudchipr.api";
import { RootState } from "@/store/store";
import { ScheduleProtectResources } from "@/store/automations/thunks/wokrflows/resources-for-protector/resourceProtectThunk";
import { isResourceKubernetes } from "@/store/resources-grid/utils/helpers/isResourceKubernetes";

export const previewSelectedResourcesToProtectSelector = (
  state: RootState,
  resourceTypes: ResourceType[],
): ScheduleProtectResources => {
  const resources = previewSelectedResourcesSelector(state, resourceTypes);

  return (
    resources?.reduce((acc, resource) => {
      if (!resource) {
        return acc;
      }

      const resourceId = resource?.id;
      const isProtected = resource?.is_protected;
      const resourceType = resource?.resource_type;

      const accountId = isResourceKubernetes(resource)
        ? undefined
        : resource.account.id;

      if (!accountId) {
        return acc;
      }

      if (!acc[accountId]) {
        acc[accountId] = [];
      }

      acc[accountId].push({
        id: resourceId,
        type: resourceType,
        is_protected: !isProtected,
      });

      return acc;
    }, {} as ScheduleProtectResources) ?? ({} as ScheduleProtectResources)
  );
};
